import React, { Component } from 'react';
import '../Styles/css/Home.css';
import SpecialAlert from '../Components/SpecialAlert';

class Home extends Component {

    state = {
        showSpecialAlert: true
    }

    render() {

        return (
            <div className="Home">
                <div className="main">
                    <h1>FLAURAL</h1>
                </div>
                {this.renderSpecialAlert()}
            </div>
        );
    }

    renderSpecialAlert() {

        if (!this.state.showSpecialAlert) {
            return null;
        }

        return <SpecialAlert onClose={() => this.handleCloseAlert()} visible={this.state.showSpecialAlert} />;
    }

    handleCloseAlert() {

        this.setState({ showSpecialAlert: false });
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Containers/Home.js